import { clone } from "lodash";

export function validateSizesForImageDimensions(imageDimensions, optionGroups, enableLowQuality = false) {
  let sizeOptionGroup = getSizeOptionGroup(optionGroups);
  let optionsCopy = clone(sizeOptionGroup.options);

  if (optionsCopy) {
    optionsCopy = optionsCopy.map(option => {
      let minDimensions = getMinimumDimensionsForSize(option);
      let heightIsValid = imageDimensions.height >= minDimensions.minHeight;
      let widthIsValid = imageDimensions.width >= minDimensions.minWidth;
      option.isValid = heightIsValid && widthIsValid;
      if (enableLowQuality) {
        if (!option.isValid) {
          option.isLowRes = true;
        } else {
          delete option.isLowRes;
        }
        option.isValid = true;
      }
      return option
    })
  }

  return optionsCopy;
}

export function getMinimumDimensionsForSize(size) {
  let minHeight = size.optionData.Height * size.minPPI - 400;
  let minWidth = size.optionData.Width * size.minPPI - 400;
  return { minHeight, minWidth };
}

export function getSizeOptionGroup(optionGroups) {
  let sizeOptionGroup = optionGroups.find(group => group.isSize);
  return sizeOptionGroup;
}
